
export class GetTeammate {
    public static readonly type: string = '[USER] Get Teammate';
}
